export enum KindergartenActReconciliationStatus {
    UPLOADED = 'UPLOADED', ACCEPTED = 'ACCEPTED', REJECTED = 'REJECTED'
}